<template>
  <div id="invSetTem">
    <el-row class="content" style="margin-top: -45px;padding: 0;">
      <!-- 时间 -->
      <el-col :xs="24" :sm="24" :lg="24" class="card-panel-col">
        <p class="contentTitle" style="display: flow-root;position: absolute;right: 2px;top: 13px;z-index: 99;">
          <el-button v-show="editBtn" type="primary" icon="el-icon-edit " style="vertical-align: top;float: right;margin-left: 10px;" @click="edit" />
          <el-button v-show="closeBtn" type="primary" icon="el-icon-close" style="vertical-align: top;float: right;" @click="close" /><!--取消-->
          <el-button v-show="viewBtn=='close'" type="primary" icon="el-icon-close" style="vertical-align: top;float: right;" @click="clickSet('close')" /><!--收起配置-->
          <el-button v-show="viewBtn=='open'" type="primary" icon="el-icon-setting" style="vertical-align: top;float: right;" :disabled="disabledEdit" @click="clickSet('open')" /><!--配置-->
          <!-- <el-button v-show="viewBtn=='open'" type="primary" icon="el-icon-setting" style="vertical-align: top;float: right;" @click="clickSet('open')" />配置 -->
        </p>
        <!-- 配置-查看 -->
        <div v-show="viewTable" class="contentWrap" style="padding:0;margin-top: 10px;">
          <div>
            <p class="btnSpace" />
            <table border="1" style="border-collapse:collapse;width:100%;border: 1px solid #537ca3;font-size:14px;">
              <thead>
                <tr>
                  <th style="width:30%">Options</th>
                  <th style="width:30%">Value</th>
                  <th style="width:40%">Remark</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item,index) in tableData" :key="index">
                  <td style="text-align: center;">{{ item.name }}</td>
                  <td style="text-align: left;">
                    <p v-if="item.key=='model'">{{ inverterType }}</p>
                    <el-switch v-if="item.key=='reset'" v-model="tableEditObj.reset" :disabled="true" active-text="ON" inactive-text="OFF" @change="resetOnOff(tableEditObj.reset)" />
                    <el-select v-if="item.key=='setInverter'" v-model="tableEditObj.setInverter" :disabled="true" class="editTableTd" placeholder="Select">
                      <el-option v-for="option in setInverterOptions" :key="option.value" :label="option.label" :value="option.value" />
                    </el-select>
                    <el-radio v-if="item.key=='setAC'" v-model="tableEditObj.setAC" label="2" :disabled="true">ON</el-radio>
                    <el-radio v-if="item.key=='setAC'" v-model="tableEditObj.setAC" label="1" :disabled="true">OFF</el-radio>

                    <el-radio v-if="item.key=='setECO'" v-model="tableEditObj.setECO" label="2" :disabled="true">ON</el-radio>
                    <el-radio v-if="item.key=='setECO'" v-model="tableEditObj.setECO" label="1" :disabled="true">OFF</el-radio>

                    <el-radio v-if="item.key=='setDCV'" v-model="tableEditObj.setDCV" label="1" :disabled="true">Low</el-radio>
                    <el-radio v-if="item.key=='setDCV'" v-model="tableEditObj.setDCV" label="2" :disabled="true">Normal</el-radio>
                    <el-radio v-if="item.key=='setDCV'" v-model="tableEditObj.setDCV" label="3" :disabled="true">High</el-radio>

                    <el-radio v-if="item.key=='setALx'" v-model="tableEditObj.setALx" label="2" :disabled="true">ON</el-radio>
                    <el-radio v-if="item.key=='setALx'" v-model="tableEditObj.setALx" label="1" :disabled="true">OFF</el-radio>

                    <el-select v-if="item.key=='setISx'" v-model="tableEditObj.setISx" class="editTableTd" placeholder="Select" :disabled="true">
                      <el-option v-for="option in setISxOptions" :key="option.value" :label="option.label" :value="option.value" />
                    </el-select>
                  </td>
                  <td style="text-align: left;padding:10px 0;">{{ item.remark }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <!-- 配置-编辑 -->
        <div v-show="editTable" class="contentWrap" style="padding:0;margin-top:10px;">
          <div>
            <p class="btnSpace" />
            <table border="1" style="border-collapse:collapse;width:100%;border: 1px solid #537ca3;font-size:14px;">
              <thead>
                <tr>
                  <th style="width:30%">Options</th>
                  <th style="width:30%">Value</th>
                  <th style="width:40%">Remark</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item,index) in tableData" :key="index">
                  <td style="text-align: center;">{{ item.name }}</td>
                  <td style="text-align: left;">
                    <p v-if="item.key=='model'">{{ inverterType }}</p>
                    <el-switch v-if="item.key=='reset'" v-model="tableEditObj.reset" active-text="ON" inactive-text="OFF" @change="resetOnOff(tableEditObj.reset)" />
                    <el-select v-if="item.key=='setInverter'" v-model="tableEditObj.setInverter" class="editTableTd" placeholder="Select" @change="change($event)">
                      <el-option v-for="option in setInverterOptions" :key="option.value" :label="option.label" :value="option.value" />
                    </el-select>
                    <el-radio v-if="item.key=='setAC'" v-model="tableEditObj.setAC" label="2" @change="change($event)">ON</el-radio>
                    <el-radio v-if="item.key=='setAC'" v-model="tableEditObj.setAC" label="1" @change="change($event)">OFF</el-radio>

                    <el-radio v-if="item.key=='setECO'" v-model="tableEditObj.setECO" label="2" @change="change($event)">ON</el-radio>
                    <el-radio v-if="item.key=='setECO'" v-model="tableEditObj.setECO" label="1" @change="change($event)">OFF</el-radio>

                    <el-radio v-if="item.key=='setDCV'" v-model="tableEditObj.setDCV" label="1" @change="change($event)">Low</el-radio>
                    <el-radio v-if="item.key=='setDCV'" v-model="tableEditObj.setDCV" label="2" @change="change($event)">Normal</el-radio>
                    <el-radio v-if="item.key=='setDCV'" v-model="tableEditObj.setDCV" label="3" @change="change($event)">High</el-radio>

                    <el-radio v-if="item.key=='setALx'" v-model="tableEditObj.setALx" label="2" @change="change($event)">ON</el-radio>
                    <el-radio v-if="item.key=='setALx'" v-model="tableEditObj.setALx" label="1" @change="change($event)">OFF</el-radio>

                    <el-select v-if="item.key=='setISx'" v-model="tableEditObj.setISx" class="editTableTd" placeholder="Select" @change="change($event)">
                      <el-option v-for="option in setISxOptions" :key="option.value" :label="option.label" :value="option.value" />
                    </el-select>
                  </td>
                  <td style="text-align: left;padding:10px 0;">{{ item.remark }}</td>
                </tr>
                <tr style="height: 40px;">
                  <td colspan="3">
                    <el-button type="primary" style="vertical-align: top;margin-right: 2px;float: right;" @click="tableSubmit('charging')">{{ $t('button.Submit') }}</el-button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>

import { findDeviceInfo, setCBBCfg, getCBBCfg } from '@/api/bidirectional'
import { howLongAgo } from '@/utils/updateTime.js'
import i18n from '@/i18n'

export default {
  name: 'Bidirectional',
  components: {
  },
  props: {
    inverterType1: {
      type: String,
      default: ''
    },
    online: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      invOnline: false,
      viewTable: false, // 表格--查看
      editTable: false, // 表格--编辑
      viewBtn: 'open', // 查看/收起配置--按钮
      editBtn: false, // 编辑--按钮
      closeBtn: false, // 取消--按钮
      tableEditObj: {
        setInverter: '',
        setAC: '',
        setECO: '',
        setDCV: '',
        setALx: '',
        setISx: ''
      },
      inverterType: null,
      tableDataAll: [
        { key: 'model', isShow: true, name: 'Model', nameZ: '型号', remark: '' },
        { key: 'reset', isShow: true, name: 'Reset Config', nameZ: '恢复默认', remark: 'Use default settings if turn on.' },
        { key: 'setInverter', isShow: true, name: 'Inverter Model', nameZ: '逆变器设置', remark: 'Operation mode: OFF=Inverter function is disable.ON=Inverter function is enable.Auto backup=Inverter automatically turns ON when AC blackout.Manual backup=Inverter has to be manually turned ON when AC blackout.Manual/Auto backup=The function is selected by user.' },
        { key: 'setAC', isShow: true, name: 'AC Output', nameZ: '电源设置', remark: 'Disable/enable AC output' },
        { key: 'setECO', isShow: true, name: 'ECO Mode', nameZ: 'ECO模式设置', remark: 'Disable/enable ECO mode (for inverter only). If enabled, AC output will be alternating between ON/OFF if loading power is less than the set value.' },
        { key: 'setDCV', isShow: true, name: 'DC Input Under Voltage', nameZ: 'DC输入电压', remark: 'There are 3 preset levels for under voltage protection.Please refer to the manual for details.' },
        { key: 'setALx', isShow: true, name: 'Audible Alarm', nameZ: '欠压警告', remark: 'Disable/enable the buzzer during alarm.' },
        { key: 'setISx', isShow: true, name: 'Ignition Start', nameZ: '响应机制', remark: 'Ignition start. Select the method to start the device.' }
      ],
      setInverterOptions: [
        {	label: 'NO',	value: '1' },
        {	label: 'Manual Backup',	value: '2' },
        {	label: 'Auto Backup',	value: '3' },
        {	label: 'Manual/Auto Backup',	value: '4' },
        {	label: 'OFF',	value: '5' }
      ],
      setISxOptions: [
        {	label: 'OFF',	value: '1' },
        {	label: 'By Power',	value: '2' },
        {	label: 'By Inverter',	value: '3' }
      ],
      disabledEdit: true
    }
  },
  computed: {
    storeYhubmqtt() {
      return this.$store.state.yhubmqtt// 需要监听的数据
    },
    tableData: function() {
      return this.tableDataAll.filter(function(item) {
        return item.isShow
      })
    }
  },
  watch: {
    storeYhubmqtt: {
      handler(newValue, oldValue) {
        this.yhubmqtt = newValue // 把新值赋值给我们的属性数据
        // console.log(this.yhubmqtt)
        // console.log(this.yhubmqtt.payload)
        this.MQTT()
      },
      deep: true
    },
    online: {
      handler(newValue, oldValue) {
        this.invOnline = newValue
        if (newValue) { this.disabledEdit = false } else { this.disabledEdit = true }
      },
      deep: true
    }
  },
  mounted() {
    // getCBBCfg({ mcuId: this.$route.query.mcuId }).then(res => {})
  },
  created() {
  },
  destroyed: function() {
  },
  methods: {
    resetOnOff(value) {
      if (!value) {
        this.tableDataAll.forEach(v => {
          v.isShow = true
        })
      } else { // 打开
        this.tableDataAll.forEach(v => {
          v.isShow = false
          if (v.key == 'model' || v.key == 'reset')v.isShow = true
        })
      }
    },
    clickSet(val) {
      if (val == 'close') { // 收起
        this.viewTable = this.editTable = this.editBtn = false
        this.viewBtn = 'open'
      } else { // 查看
        getCBBCfg({ mcuId: this.$route.query.mcuId }).then(res => {})
        this.editBtn = this.viewTable = true
        this.viewBtn = 'close'
      }
    },
    edit() {
      this.viewBtn = ''
      this.editTable = this.closeBtn = true
      this.viewTable = this.editBtn = false
    },
    close() {
      this.editTable = this.closeBtn = false
      this.viewBtn = 'close'
      this.viewTable = this.editBtn = true
    },
    change(e) {
      this.$forceUpdate()
    },
    tableSubmit() {
      var param = {
        'mcuId': this.$route.query.mcuId,
        // 'set_inverter': this.tableEditObj.setInverter,
        // 'set_AC': this.tableEditObj.setAC,
        // 'set_ECO': this.tableEditObj.setECO,
        // 'set_DC_V': this.tableEditObj.setDCV,
        // 'set_ALx': this.tableEditObj.setALx,
        // 'set_ISx': this.tableEditObj.setISx,
        'model': 0
      }
      if (this.tableEditObj.setInverter) param.set_inverter = this.tableEditObj.setInverter
      if (this.tableEditObj.setAC) param.set_AC = this.tableEditObj.setAC
      if (this.tableEditObj.setECO) param.set_ECO = this.tableEditObj.setECO
      if (this.tableEditObj.setDCV) param.set_DC_V = this.tableEditObj.setDCV
      if (this.tableEditObj.setALx) param.set_ALx = this.tableEditObj.setALx
      if (this.tableEditObj.setISx) param.set_ISx = this.tableEditObj.setISx
      if (this.tableEditObj.reset) { param.defaults = 0 } else { param.defaults = 1 }
      this.$confirm('submit change?', '', {// '是否提交修改？'
        confirmButtonText: 'Confirm', // '确定',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
        setCBBCfg(param).then(res => {
          if (res.code == 200) {
            this.$message({
              type: 'success',
              message: 'Succeed!'
            })
            this.viewTable = this.editBtn = true
            this.editTable = this.closeBtn = false
            this.viewBtn = 'close'
          }
        })
      }).catch(() => {
      })
    },
    MQTT() {
      if (this.yhubmqtt) {
        // console.log('yhubmqtt-----', this.yhubmqtt)
        // this.$route.query.mcuId = '05d6ff393430475043165127'
        if (!this.yhubmqtt.topic || this.yhubmqtt.topic.indexOf(this.$route.query.mcuId) == -1) return
        if (this.yhubmqtt.payload === 'mCan') {
          // console.log('this.yhubmqtt---', this.yhubmqtt.mCan)
          if (!this.yhubmqtt.mCan) return
          if (this.yhubmqtt.mCan.payload && this.yhubmqtt.mCan.payload == 'mGetCANCfgData') {
            if (!this.yhubmqtt.mCan.mGetCANCfgData.CBBcfg) {
              return
            }
            if (this.yhubmqtt.mCan.mGetCANCfgData.CBBcfg) {
              this.disabledEdit = false
              var CBBcfg = this.yhubmqtt.mCan.mGetCANCfgData.CBBcfg
              console.log('CBBcfg-----', this.yhubmqtt.mCan.mGetCANCfgData.CBBcfg)
              this.tableEditObj.setInverter = CBBcfg.setInverter.toString()
              this.tableEditObj.setAC = CBBcfg.set_AC.toString()
              this.tableEditObj.setECO = CBBcfg.set_ECO.toString()
              this.tableEditObj.setDCV = CBBcfg.set_DC_V.toString()
              this.tableEditObj.setALx = CBBcfg.set_ALx.toString()
              this.tableEditObj.setISx = CBBcfg.set_ISx.toString()
            }
          }
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
p{
  margin:0
}
.bag{
  background:#e0e0e085;
}
.card-panel{
  padding-bottom: 20px;
}
#invSetTem{
  .content{
    // background:white;
    margin-top: 32px;
    padding: 20px;
  }
  .contentWrap {
    background: #27679e;
  }
  .middleContentWarp{
    padding:0 5%;
    // border:1px solid red;
    height: 550px;
    width: 100%;
    // background: white;
    padding-top: 20px;
  }
  .middleContentLeft{
    // height: 300px;
    // border:1px solid red;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .middleContentLeft>div{
    // border:1px solid red;
    // width:100px;
    // height:200px;
  }
  .plugWarp>div:nth-of-type(1){
    display: flex;
    justify-content: center;
  }
  .plugWarp>div:nth-of-type(1) img{
    width: 100px;
    margin-bottom: 10px;
  }
  .plugWarp>div:nth-of-type(2){
    text-align: center;
  }
  .plugWarp>div:nth-of-type(2) img{
    width:30px;
  }
  .plugWarp>div:nth-of-type(2) span{
    line-height: 30px;
    vertical-align: top;
  }
  .soildLine{
    width:100px;
    border-top:3px solid #63bb38;
  }
  .greenDeltaRight{//向右三角形
    width: 0;
    height: 0;
    border-left: 15px solid #63bb38;
    border-top: 10px solid transparent;
    border-bottom: 10px solid transparent;
  }
  .acChargeDiv{
    position: relative;
  }
  .acChargeDiv div:first-child p{
    text-align: center;
  }
  .acChargeDiv>div{
    display: inline-block;
  }
  .acChargeDiv .acChargeInfo{
    vertical-align: top;
  }
  .acChargeInfo>div{
    margin-top:40px;
  }
  .temInfo{
    display: flex;
    align-items: center;
    position: absolute;
    right: 20px;
    top: -45px;
  }

  .middleContentRight{
    height: 400px;
    // border:1px solid red;
    position: relative;
    padding-left: 20px;
  }
  .middleContentRight>div{
    // border:1px solid red;
    // height:80px;
    position: absolute;
  }
  .arrowOrLine{
    border-top: 3px solid #63bb38;
    border-right: 3px solid #63bb38;
    position: relative;
  }
  .greenDeltaBottom{
    position: absolute;
    bottom: -5px;
    right: -11px;
  }
  .middleContentRight>div:nth-of-type(1){
    width:calc(100% - 100px);
    top: 47px;
    height: 74px;
  }
  .middleContentRight>div:nth-of-type(2){
    width:calc(100% - 280px);
    top: 105px;
    height: 96px;
  }
  .middleContentRight>div:nth-of-type(3){
    width:calc(100% - 460px);
    top: 162px;
    height: 118px;
  }
  .middleContentRight>div:nth-of-type(4){
    right: 0;
    top: 130px;
  }
  .middleContentRight>div:nth-of-type(5){
    right: 180px;
    top: 210px;
  }
  .middleContentRight>div:nth-of-type(6){
    right: 360px;
    top: 290px;
  }
  .greenDeltaBottom{//向下三角形
    width: 0;
    height: 0;
    border-top: 15px solid #63bb38;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
  }
  .cellTeamBoxImg{
    display: flex;
    justify-content: center;
  }
  .cellTeamBox>img{
    width: 160px;
  }
  .cellTeamBoxInfo{
    text-align: center;
  }
  .cellTeamBoxInfo img{
    width:30px;
  }
  .cellTeamBoxInfo span{
    line-height: 30px;
    vertical-align: top;
  }
  .dottedLine{
   border-top: 3px dotted #e3e3e3;
   border-right: 3px dotted #e3e3e3;
  }
  .warningIcon{
    width: 20px!important;
    position:absolute;
    top: -5px;
    left: -10px;
  }
  .warningWarp{
    padding: 0px 5%;
    display: inline-block;
    width:90%;
  }
  .warningWarp img{
    width: 50px;
  }
  .warningWarp .warningImgAndP{
    display: flex;
    align-items: center;
  }
  .warningWarp .warningImgAndP span{
    margin-left: 10px;
    // color: red;
  }
  .warningWarp .warningP{
    margin-top: 10px;
    color: blue;
  }
  .acChargeWarp{
    padding:0 5%;
  }
  // .acChargeDiv{
  //   position: relative;
  // }
  .acChargeImg{
    width:150px;
    // border:1px solid red;
  }
}
</style>
<style lang="scss">
#invSetTem{
  .btnSpace{
    height: 40px;
    border: 1px solid #537ba3;
    border-bottom: none;
  }
  .el-radio {
    color: #fff;
  }
  .el-switch__label.is-active {
    color: #1990fc;
  }
  .el-switch__label {
    color: #ffffff;
  }
}
</style>
